/* eslint-disable camelcase */

// these should all be lowercase because it's used as part of the css class
export const DRAWERS = {
	errors: "Pub Errors 🚨",
	goodies: "Goodies",
	experiments: "Experiments",
	pagelinks: "Links",
	servers: "Servers",
	settings: "Settings",
	inspector: "Inspect Vars",
	overrides: "Overrides",
	appEnvironment: "Environment",
	appPage: "Go to Page",
	speed: "Speed",
	js: "JS",
	refresh: "Refresh",
};

// ways to open the staffbar
export const OPEN_MODELS = {
	keysonly: "keysonly",
	pinned: "pinned",
	mouseover: "mouseover",
};

export const OPEN_MODEL_DESCRIPTIONS = {
	keysonly: "Toggle with the `~` key",
	pinned: "Always open",
	mouseover: "Toggle with mouse",
};

export const SERVER_COUNT = 70;

export default {};



// WEBPACK FOOTER //
// ./src/apps/staffbar/util/constants.js